import { AxiosRequestConfig } from "axios";
import baseApi, { fetchApi, version1 } from "../../Libs/Config/APIConfig";
import {
  ChangePasswordPayload,
  LoginPayload,
} from "../../Libs/Types/API-Payloads";
import { BEARER_TOKEN } from "../../Libs/Utils/utils";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}

const LoginDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

const AuthDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiLogin = async (payload: LoginPayload) => {
  return baseApi.post(`/api/${version1}/auth/login`, payload, LoginDataConfig);
};

export const apiChangePassword = async (payload: ChangePasswordPayload) => {
  const configWithAuth: CustomAxiosRequestConfig = {
    ...AuthDataConfig,
    headers: {
      ...AuthDataConfig.headers,
      Authorization: `Bearer ${BEARER_TOKEN}`,
    },
  };
  return fetchApi.patch(
    `/api/${version1}/auth/change-password`,
    payload,
    configWithAuth
  );
};
